import { internalFetch, postCsv } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface ILabel {
  id: number;
  labelSet: string;
  key: string;
  label: string;
  version?: number;
  isDeleted?: boolean | null;
  createdAt?: string;
  modifiedAt?: string | null;
}

export interface ICreateLabelRequest {
  labelSet: string;
  label: string;
  key: string;
}

export interface ICreateLabelResponse {
  labelId: number;
  isSuccess: boolean;
  message: string | null;
  correlationId: string;
}

export interface IUpdateLabelRequest {
  labelSet: string;
  label: string;
  key: string;
  isDeleted: boolean;
}

export const getLabelsets = async (
  abortController: AbortController
): Promise<string[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/labelsets?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getLabels = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  labelsSet: string,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<ILabel>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/labels/?labelsSet=${encodeURIComponent(
      labelsSet
    )}&pageSize=${pageSize}&pageNo=${pageNo}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const createLabel = async (
  abortController: AbortController,
  label: ICreateLabelRequest
): Promise<ICreateLabelResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/label`,
    'POST',
    abortController,
    JSON.stringify(label)
  );
};

export const updateLabel = async (
  abortController: AbortController,
  labelId: number,
  label: IUpdateLabelRequest
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/label?labelId=${labelId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(label)
  );
};

export const deleteLabel = async (
  abortController: AbortController,
  labelId: number
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/label?labelId=${labelId}`,
    'DELETE',
    abortController
  );
};

export interface IImportLabelsResponse {
  createdCount: number;
  updatedCount: number;
  errors: string[];
  isSuccess: boolean;
  message: string | null;
  correlationId: string;
}

export const importLabels = (
  abortController: AbortController,
  csvContent: string
): Promise<IImportLabelsResponse> =>
  postCsv<IImportLabelsResponse>(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/importLabels`,
    csvContent,
    abortController
  );

export const exportLabels = async (
  abortController: AbortController,
  labelSets: string[]
): Promise<string> => {
  const response: Response = await internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/exportLabels?labelSets=${encodeURIComponent(
      labelSets.join(',')
    )}&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController,
    undefined,
    true
  );

  return response.text();
};
